$(document).ready(function(){

  $('.template-index').addClass('active');
  
  $('.sbsp_btn').on('click', function(){
    if($(this).hasClass('sbsp_onetime')){
      $(this).closest('.sbsp_info').find('.sbsp_onetime_detail, .sbsp_btn_box').slideToggle(); 
    }
  });
  
  $("#sign-in").click(function(){
    $("#abc").show();
  });

  /*
  setTimeout(function(){
     $('.parallax-window').parallax({
      naturalWidth: 600,
      naturalHeight: 400
    });
  }, 4500);
  */

  
  var password = 'bonito';
  $('.whlpd_btn').on('click', function(){
     var value = $('.whlpd_password').val();
     if(value == password){
       setCookie('password', 1, 1);
       $('.whlpd_full_width').hide();
       $('body').addClass('active');
     }else{
       alert('Please try again');
     }
  });
  if(getCookie('password') == 1){
    $('.whlpd_full_width').hide();
    $('body').addClass('active');
  }

   $('.read_more_btn').on('click', function(){
     $(this).toggleClass('active');
     $('.more_description').slideToggle();
   });


  $('.hpp_bg, .hpp_img').on('click', function(){
    $('.hpp_section').hide();
    setCookie('hpp', 1, 1);
  });
  
  if(getCookie('hpp') != 1){
     $('.hpp_section').show();
  }
  
});



function setCookie(name, value, expiry) {
    let d = new Date();
    d.setTime(d.getTime() + (expiry*86400000));
    document.cookie = name + "=" + value + ";" + "expires=" + d.toUTCString() + ";path=/";
}

function getCookie(name) {
    let cookie = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return cookie ? cookie[2] : null;
}

function eatCookie(name) {
    setCookie(name, "", -1);
}


/*- Header Pop Up Modal -------------*/

/*

$(function() {
  $(".header_signUp_form").on("click", function(e) {
    e.preventDefault();
       $(".header_popup_box").fadeTo(100, 1).removeClass("open_modal").addClass("open_modal");
     $("body").addClass("body_overlay");
  });
  $(document).on("click", ".overlay", function() {
    $(".header_popup_box").addClass("boom-out").removeClass("open_modal").fadeTo(100, 0);
    $("body").removeClass("body_overlay")

  });

});

*/


                           
$(function() {
  var appendthis = "<div class='overlay'></div>";
  /*
  $(".header_signUp_form").on("click", function(e) {
    e.preventDefault();
    $("body").append(appendthis);
    $(".overlay").fadeTo(500, 0.7);
    $(".header_popup_box").fadeTo(100, 1).removeClass("open_modal").addClass("open_modal");
  });
  */
  $(document).on("click", ".overlay", function() {
    $(".header_popup_box").addClass("boom-out").removeClass("open_modal").fadeTo(100, 0);

    $(".overlay").fadeOut(500, function() {
      $(this).remove();
    });
  });

  $('.popupContact_close').on("click", function(e){
    $(".header_popup_box").fadeOut().addClass("open_modal").removeClass("open_modal");
  });
 

});






var bonito = {
  combo: function() {

    $('.checkselected_products').on('change', function(){
       $(this).closest('.sbsp_item').find('.bonito_hideshow').slideToggle();
    });
    
    $('.bonito_addToCart').on('click', function(){
        var time = 0;
      
      $('.sbsp_flx .sbsp_item').each(function() {
          if($(this).find('.checkselected_products').is(':checked')){
             var form_id = $(this).find('form').attr("id");
             addto_form(form_id, time);
             time += 2500;
          }
      });

      setTimeout(function() {
         window.location.href = "/cart";
      },time);
      
    });


    function addto_form(form_id, time){
       
      setTimeout(function() {
          
          $.ajax({
             type: 'POST',
              url: '/cart/add.js',
              data: $('#' + form_id).serialize(),
              dataType: 'json',
              success: function(line_item) { 
                 console.log('done');
              },
              error: function(XMLHttpRequest, textStatus) {
                console.log(XMLHttpRequest, textStatus);
              }
          });

         }, time); 
    }
    
  },
  subscribe_select: function() {
      $('[data-bsub-selling-plan-group] [type="radio"]').prop('checked', true).attr('checked', 'checked');
  },
  all_options: function() {
    
     $('.cart__note_btn').on('click', function() {
        $('.cart__note_box').slideToggle();
     });
    
  },
  account: function() {

    $('cart-remove-button a').on('click', function(){
      var href = $(this).attr('href');
      window.location.href = href;
    });
    
    $('.show_password').on('click', function(){
        $(this).toggleClass('active');
        if($(this).closest('.password_box').hasClass('active')){
           $(this).closest('.password_box').find('.input_password').attr('type', 'password');          
        }else{
          $(this).closest('.password_box').find('.input_password').attr('type', 'text');
        }
        $(this).closest('.password_box').toggleClass('active');
    });
  },
  slider_function: function() {
    
    $('.card_product_slider').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        arrows: false,
        autoplay: true 
      });    
  }
}

$(function(){
  bonito.combo();
  bonito.subscribe_select();
  bonito.all_options();
  bonito.account();
  bonito.slider_function();
})
